import { render, staticRenderFns } from "./creative.vue?vue&type=template&id=5f2800a8&scoped=true"
import script from "./creative.vue?vue&type=script&lang=js"
export * from "./creative.vue?vue&type=script&lang=js"
import style0 from "./creative.vue?vue&type=style&index=0&id=5f2800a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2800a8",
  null
  
)

export default component.exports